import React, { useEffect, useState } from "react";
import "./../styles/transaction.css";
import AccountLayout from "../layouts/AccountLayout";
import { HashLoader } from "react-spinners";
import { getDepositHistoryList } from "../api/transaction.api";
import showToast from '../components/toasts/ToastNotification';
import { transactionHistoryPaymentMethodText } from "../utils";
import Pagination from "../components/pagination/Pagination";
import { PiBankFill } from "react-icons/pi";
import { BiSolidCreditCardFront } from "react-icons/bi";
import { FaWallet } from "react-icons/fa";


const ITEMS_PER_PAGE = 8;

const DepositHistory = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                setLoading(true);
                const res = await getDepositHistoryList(50);
                if (res.success) {
                    setTransactions(res.data.transactions);
                }
            } catch (error) {
                showToast(error.message, "error");
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();
    }, []);

    const totalPages = Math.ceil(transactions.length / ITEMS_PER_PAGE);
    const currentTransactions = transactions.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );
    const successfulCount = transactions.filter((tx) => ["success", "completed"].includes(tx.transactionStatus)).length;
    const pendingCount = transactions.filter((tx) => tx.transactionStatus === "pending").length;
    const failedCount = transactions.filter((tx) => tx.transactionStatus === "failed").length;

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    const formatStatus = (status) => {
        switch (status) {
            case "pending":
                return "Đang chờ";
            case "success":
                return "Thành công";
            case "completed":
                return "Thành công"
            case "failed":
                return "Thất bại";
            default:
                return "Empty status";
        }
    };

    const getDepositStatusClass = (status) => {
        if (status === "success" || status === "completed") return "deposit-status-success";
        if (status === "failed") return "deposit-status-failed";
        return "deposit-status-neutral";
    };

    const getPaymentMethodIcon = (method) => {
        switch (method) {
            case "bank_transfer":
                return <PiBankFill className="payment-method-icon" />;
            case "card":
                return <BiSolidCreditCardFront className="payment-method-icon" />;
            case "momo":
                return <FaWallet className="payment-method-icon" />;
            default:
                return <FaWallet className="payment-method-icon" />;
        }
    };


    return (
        <AccountLayout title={'Lịch sử nạp tiền'}>
            <div className="transaction-container">
                <div className="transaction-page-head">
                    <h3 className="transaction-title">Lịch sử nạp tiền</h3>
                    <p className="transaction-subtitle">Theo dõi toàn bộ giao dịch nạp tiền của bạn theo thời gian thực.</p>
                </div>

                <div className="transaction-kpi-grid">
                    <div className="transaction-kpi-card">
                        <p className="kpi-label">Thành công</p>
                        <p className="kpi-value success-status">{successfulCount}</p>
                    </div>
                    <div className="transaction-kpi-card">
                        <p className="kpi-label">Đang chờ</p>
                        <p className="kpi-value pending-status">{pendingCount}</p>
                    </div>
                    <div className="transaction-kpi-card">
                        <p className="kpi-label">Thất bại</p>
                        <p className="kpi-value failed-status">{failedCount}</p>
                    </div>
                </div>

                {loading ? (
                    <div className="loader-container">
                        <HashLoader color="var(--hash-loader-color)" size={30} />
                    </div>
                ) : (
                    <>
                        <div className="transaction-table-shell">
                            <table className="transaction-table">
                                <thead>
                                    <tr>
                                        <th>Mã giao dịch</th>
                                        <th>Trạng thái</th>
                                        <th>Thời gian</th>
                                        <th>Số tiền</th>
                                        <th>Phương thức</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentTransactions.length > 0 ? (
                                        currentTransactions.map((tx) => (
                                            <tr key={tx.transactionId}>
                                                <td>{tx.transactionId}</td>
                                                <td className={`transaction-status ${getDepositStatusClass(tx.transactionStatus)}`}>
                                                    {formatStatus(tx.transactionStatus)}
                                                </td>
                                                <td>{new Date(tx.updatedAt).toLocaleString()}</td>
                                                <td>
                                                    <span className="amount-pill amount-pill-primary">
                                                        {tx.amount.toLocaleString()}đ
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="payment-method-chip">
                                                        {getPaymentMethodIcon(tx.paymentMethod)}
                                                        {transactionHistoryPaymentMethodText(tx.paymentMethod)}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="table-empty-cell">Không có giao dịch nào.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {totalPages > 1 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPrev={handlePrevPage}
                                onNext={handleNextPage}
                            />
                        )}
                    </>
                )}
            </div>
        </AccountLayout>
    );
};

export default DepositHistory;
